import Svg from 'components/utilities/svg'

const CornerRadiusIcon = ({ ...props }) => (
  <Svg viewBox="-3 -3 20 20" {...props}>
    <title>Corner Radius Icon</title>

    <path d="M10 14H8V9c0-.833-.292-1.542-.875-2.125A2.893 2.893 0 0 0 5 6H0V4h5c1.383 0 2.563.487 3.537 1.463C9.512 6.437 10 7.617 10 9v5ZM14 0v2h-2V0zM14 4v2h-2V4zM14 8v2h-2V8zM14 12v2h-2v-2zM10 0v2H8V0zM6 0v2H4V0zM2 0v2H0V0z" />
  </Svg>
)

CornerRadiusIcon.displayName = 'CornerRadius'

export default CornerRadiusIcon
